/**
 * The widgets every domain can use. A pack adds its own (DomainPack.widgets); a pack's widget with
 * the same key replaces the generic one.
 */
import { report } from '../core/diagnostics';
import type { WidgetDefinition } from './contract';
import { attract } from './generic/Attract';
import { choiceGrid } from './generic/ChoiceGrid';
import { counters } from './generic/Counters';
import { form } from './generic/Form';
import { keypad } from './generic/Keypad';
import { message } from './generic/Message';
import { summary } from './generic/Summary';
import { ticket } from './generic/Ticket';

export const GENERIC_WIDGETS = [attract, choiceGrid, counters, form, keypad, message, summary, ticket] as unknown as WidgetDefinition<never>[];

export function widgetRegistry(extra: readonly WidgetDefinition<never>[] = []): Map<string, WidgetDefinition<never>> {
  const map = new Map<string, WidgetDefinition<never>>();
  for (const w of GENERIC_WIDGETS) map.set(w.key, w);
  for (const w of extra) {
    if (map.has(w.key)) report('info', 'widgets', `the domain replaces the generic widget "${w.key}"`);
    map.set(w.key, w);
  }
  return map;
}
